import { dynamic } from './dynamic';
import { omitProps } from './omitProps';
import { isIntent } from '../intent';
export function createVariants(variants, forward = {}, createViewOptionsIntent) {
    function addIntents(intents, value) {
        // TODO: This duplicates logic from `normalizeIntents`
        if (isIntent(value)) {
            intents.push(value);
        } else if (Array.isArray(value)) {
            intents.push(...value);
        } else {
            intents.push(...createViewOptionsIntent(value));
        }
    }
    const variantKeys = Object.keys(variants);
    const omitKeys = forward ? variantKeys.filter((key)=>!forward[key]) : variantKeys;
    const sharedIntents = [];
    if (omitKeys.length) {
        const omitObj = {};
        omitKeys.forEach((key)=>{
            omitObj[key] = true;
        });
        sharedIntents.push(omitProps(omitObj));
    }
    return dynamic((props)=>{
        const intents = sharedIntents.slice();
        for(let i = 0; i < variantKeys.length; i++){
            const key = variantKeys[i];
            const value = props[key];
            const variantKeyObj = variants[key];
            const variantIntents = typeof variantKeyObj === 'function' ? variantKeyObj(value) : variantKeyObj[value];
            if (variantIntents != null) {
                addIntents(intents, variantIntents);
            }
        }
        return intents;
    });
}

//# sourceMappingURL=createVariants.js.map